<template>
  <Tooltip>
    <template #element>
      <slot/>
    </template>
    <template #content>
      <span v-if="active">
        Berechnet aus deinen Wachstumszielen, der Potential-Einordnung dieser Methode und dem Erfolg ähnlicher Formate.
      </span>
      <span v-else="active">
        Im Studio Pro analysiert die Kompass-KI fortlaufend dein Wachstum und die Wirksamkeit jeder Methode.
        Navigiere im Hauptmenü auf „Kompass-KI aktivieren“, um diese Insights freizuschalten
      </span>
    </template>
  </Tooltip>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';

const store = useStore();

const parent = computed(() => store.getters['context/context']);
const active = computed(() => parent.value.active);
</script>

<style scoped>
.info-icon
{
  @apply h-5 w-5 inline-block;
  @apply text-gray-400;
}
</style>
